<i18n lang="yaml">
en:
  title: 'Page not found'
  text1: 'The page you requested has been deleted or moved.'
  text2: 'You can go to the'
  text3: 'main page'
ru:
  title: 'Страница не найдена'
  text1: 'Запрашиваемая страница удалена или перемещена.'
  text2: 'Вы можете перейти на'
  text3: 'главную страницу'
</i18n>

<template>
  <div class="error-page">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 offset-xl-3 offset-lg-2">
          <h2
            class="error-page__title"
            v-html="$t('title')"
          ></h2>
          <p class="error-page__info">
            {{ $t('text1') }}<br>
            {{ $t('text2') }}
            <nuxt-link :to="localePath('/')">
              {{ $t('text3') }}
            </nuxt-link>.
          </p>
        </div>
        <div class="col-lg-3">
          <img
            class="error-page__image"
            :src="require('~/assets/images/error/404.svg?inline').default"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss">
.error-page {
  padding: 115px 0 100px;
}

.error-page__title {
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 40px;
  line-height: 48px;

  @media (max-width: $breakpoint-md) {
    text-align: center;
  }
}

.error-page__info {
  margin: 0;

  @media (max-width: $breakpoint-md) {
    margin-bottom: 16px;
    text-align: center;
  }
}

.error-page__image {
  @media (max-width: $breakpoint-md) {
    display: block;
    margin: 0 auto;
  }
}
</style>